import { useTranslation } from 'react-i18next';
import '../../pages/production/ProductionInsightsPage.css';

/** Lightweight shell shown while the insights route chunk loads. */
export default function InsightsPageFallback() {
  const { t } = useTranslation();

  return (
    <div className="ins-page">
      <div className="ins-header">
        <h2 className="ins-title">{t('insights.title')}</h2>
        <div className="ins-period-pills">
          <div className="ins-period-pill active">{t('common.today')}</div>
          <div className="ins-period-pill">{t('common.thisWeek')}</div>
          <div className="ins-period-pill">{t('common.thisMonth')}</div>
        </div>
      </div>
      <div className="ins-stats-row">
        <div className="ins-stat-card ins-skeleton" />
        <div className="ins-stat-card ins-skeleton" />
        <div className="ins-stat-card ins-skeleton" />
      </div>
      <div className="ins-card ins-card-skeleton" />
    </div>
  );
}
